/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Domain Admin Service
 * OpenAPI spec version: v1
 */
import type {
  AddCertificateToTenantResponseDto,
  CertificateType,
  CreatePersonDto,
  CreateTenantDto,
  DynoInventoryItemDto,
  GetAdminUsersParams,
  GetCertificateDto,
  IAddUserAddUsersUsers,
  IAddUserToGroupResult,
  IAvailableUsersAvailableUsers,
  ICreateTenantInsertTenantItems,
  IGetTenantByIdTenantNodes,
  IGetTenantsTenantNodes,
  IGetUsersByGroupGroupsUsers,
  IUpdateTenantStatusUpdateTenantItems,
  PutTenantsTenantIdCertificatesClientAuthBody,
  PutTenantsTenantIdCertificatesSmimeDecryptionBody,
  PutTenantsTenantIdCertificatesSmimeEncryptionBody,
  UpdatePersonDto,
  UpdateTenantDto,
  UpdateTenantResponseDto,
  UserRole
} from './models';

import { customInstance } from '../generatedClientConfig';



  export const getDomainAdminService = () => {
const getAdminUsers = (
    params?: GetAdminUsersParams,
 ) => {
      return customInstance<IGetUsersByGroupGroupsUsers[]>(
      {url: `/AdminUsers`, method: 'GET',
        params
    },
      );
    }
  
const postAdminUsersProviderUserIdSuperadmin = (
    providerUserId: string | null,
 ) => {
      return customInstance<IAddUserToGroupResult>(
      {url: `/AdminUsers/${providerUserId}/superadmin`, method: 'POST'
    },
      );
    }
  
const deleteAdminUsersId = (
    id: string | null,
 ) => {
      return customInstance<boolean>(
      {url: `/AdminUsers/${id}`, method: 'DELETE'
    },
      );
    }
  
const getTenantsTenantIdCertificateCertificateType = (
    tenantId: string | null,
    certificateType: CertificateType,
 ) => {
      return customInstance<GetCertificateDto>(
      {url: `/tenants/${tenantId}/certificate/${certificateType}`, method: 'GET'
    },
      );
    }
  
const getTenantsTenantIdCertificatesCertificateTypeDownload = (
    tenantId: string | null,
    certificateType: CertificateType,
 ) => {
      return customInstance<void>(
      {url: `/tenants/${tenantId}/certificates/${certificateType}/download`, method: 'GET'
    },
      );
    }
  
const putTenantsTenantIdCertificatesSmimeDecryption = (
    tenantId: string | null,
    putTenantsTenantIdCertificatesSmimeDecryptionBody: PutTenantsTenantIdCertificatesSmimeDecryptionBody,
 ) => {const formData = new FormData();
if(putTenantsTenantIdCertificatesSmimeDecryptionBody.File !== undefined && putTenantsTenantIdCertificatesSmimeDecryptionBody.File !== null) {
 formData.append(`File`, putTenantsTenantIdCertificatesSmimeDecryptionBody.File)
 }
if(putTenantsTenantIdCertificatesSmimeDecryptionBody.TenantRevision !== undefined) {
 formData.append(`TenantRevision`, putTenantsTenantIdCertificatesSmimeDecryptionBody.TenantRevision.toString())
 }
if(putTenantsTenantIdCertificatesSmimeDecryptionBody.Password !== undefined && putTenantsTenantIdCertificatesSmimeDecryptionBody.Password !== null) {
 formData.append(`Password`, putTenantsTenantIdCertificatesSmimeDecryptionBody.Password)
 }
if(putTenantsTenantIdCertificatesSmimeDecryptionBody.PublicKey !== undefined && putTenantsTenantIdCertificatesSmimeDecryptionBody.PublicKey !== null) {
 formData.append(`PublicKey`, putTenantsTenantIdCertificatesSmimeDecryptionBody.PublicKey)
 }
if(putTenantsTenantIdCertificatesSmimeDecryptionBody.PrivateKey !== undefined && putTenantsTenantIdCertificatesSmimeDecryptionBody.PrivateKey !== null) {
 formData.append(`PrivateKey`, putTenantsTenantIdCertificatesSmimeDecryptionBody.PrivateKey)
 }

      return customInstance<AddCertificateToTenantResponseDto>(
      {url: `/tenants/${tenantId}/certificates/smime-decryption`, method: 'PUT',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      );
    }
  
const putTenantsTenantIdCertificatesSmimeEncryption = (
    tenantId: string | null,
    putTenantsTenantIdCertificatesSmimeEncryptionBody: PutTenantsTenantIdCertificatesSmimeEncryptionBody,
 ) => {const formData = new FormData();
if(putTenantsTenantIdCertificatesSmimeEncryptionBody.File !== undefined && putTenantsTenantIdCertificatesSmimeEncryptionBody.File !== null) {
 formData.append(`File`, putTenantsTenantIdCertificatesSmimeEncryptionBody.File)
 }
if(putTenantsTenantIdCertificatesSmimeEncryptionBody.TenantRevision !== undefined) {
 formData.append(`TenantRevision`, putTenantsTenantIdCertificatesSmimeEncryptionBody.TenantRevision.toString())
 }
if(putTenantsTenantIdCertificatesSmimeEncryptionBody.Password !== undefined && putTenantsTenantIdCertificatesSmimeEncryptionBody.Password !== null) {
 formData.append(`Password`, putTenantsTenantIdCertificatesSmimeEncryptionBody.Password)
 }
if(putTenantsTenantIdCertificatesSmimeEncryptionBody.PublicKey !== undefined && putTenantsTenantIdCertificatesSmimeEncryptionBody.PublicKey !== null) {
 formData.append(`PublicKey`, putTenantsTenantIdCertificatesSmimeEncryptionBody.PublicKey)
 }
if(putTenantsTenantIdCertificatesSmimeEncryptionBody.PrivateKey !== undefined && putTenantsTenantIdCertificatesSmimeEncryptionBody.PrivateKey !== null) {
 formData.append(`PrivateKey`, putTenantsTenantIdCertificatesSmimeEncryptionBody.PrivateKey)
 }

      return customInstance<AddCertificateToTenantResponseDto>(
      {url: `/tenants/${tenantId}/certificates/smime-encryption`, method: 'PUT',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      );
    }
  
const putTenantsTenantIdCertificatesClientAuth = (
    tenantId: string | null,
    putTenantsTenantIdCertificatesClientAuthBody: PutTenantsTenantIdCertificatesClientAuthBody,
 ) => {const formData = new FormData();
if(putTenantsTenantIdCertificatesClientAuthBody.File !== undefined && putTenantsTenantIdCertificatesClientAuthBody.File !== null) {
 formData.append(`File`, putTenantsTenantIdCertificatesClientAuthBody.File)
 }
if(putTenantsTenantIdCertificatesClientAuthBody.TenantRevision !== undefined) {
 formData.append(`TenantRevision`, putTenantsTenantIdCertificatesClientAuthBody.TenantRevision.toString())
 }
if(putTenantsTenantIdCertificatesClientAuthBody.Password !== undefined && putTenantsTenantIdCertificatesClientAuthBody.Password !== null) {
 formData.append(`Password`, putTenantsTenantIdCertificatesClientAuthBody.Password)
 }
if(putTenantsTenantIdCertificatesClientAuthBody.PublicKey !== undefined && putTenantsTenantIdCertificatesClientAuthBody.PublicKey !== null) {
 formData.append(`PublicKey`, putTenantsTenantIdCertificatesClientAuthBody.PublicKey)
 }
if(putTenantsTenantIdCertificatesClientAuthBody.PrivateKey !== undefined && putTenantsTenantIdCertificatesClientAuthBody.PrivateKey !== null) {
 formData.append(`PrivateKey`, putTenantsTenantIdCertificatesClientAuthBody.PrivateKey)
 }

      return customInstance<AddCertificateToTenantResponseDto>(
      {url: `/tenants/${tenantId}/certificates/client-auth`, method: 'PUT',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      );
    }
  
const getTenantsTenantIdUsers = (
    tenantId: string | null,
 ) => {
      return customInstance<IGetUsersByGroupGroupsUsers[]>(
      {url: `/tenants/${tenantId}/users`, method: 'GET'
    },
      );
    }
  
const postTenantsTenantIdUsers = (
    tenantId: string | null,
    createPersonDto: CreatePersonDto,
 ) => {
      return customInstance<IAddUserToGroupResult>(
      {url: `/tenants/${tenantId}/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPersonDto
    },
      );
    }
  
const deleteTenantsTenantIdUsersUserId = (
    tenantId: string | null,
    userId: string | null,
 ) => {
      return customInstance<boolean>(
      {url: `/tenants/${tenantId}/users/${userId}`, method: 'DELETE'
    },
      );
    }
  
const putPersonsId = (
    id: string | null,
    updatePersonDto: UpdatePersonDto,
 ) => {
      return customInstance<DynoInventoryItemDto>(
      {url: `/persons/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePersonDto
    },
      );
    }
  
const getTenants = (
    
 ) => {
      return customInstance<IGetTenantsTenantNodes[]>(
      {url: `/tenants`, method: 'GET'
    },
      );
    }
  
const postTenants = (
    createTenantDto: CreateTenantDto,
 ) => {
      return customInstance<ICreateTenantInsertTenantItems>(
      {url: `/tenants`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTenantDto
    },
      );
    }
  
const getTenantsId = (
    id: string | null,
 ) => {
      return customInstance<IGetTenantByIdTenantNodes>(
      {url: `/tenants/${id}`, method: 'GET'
    },
      );
    }
  
const putTenantsId = (
    id: string | null,
    updateTenantDto: UpdateTenantDto,
 ) => {
      return customInstance<UpdateTenantResponseDto>(
      {url: `/tenants/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateTenantDto
    },
      );
    }
  
const putTenantsIdRevisionActive = (
    id: string | null,
    revision: number,
    active: boolean,
 ) => {
      return customInstance<IUpdateTenantStatusUpdateTenantItems[]>(
      {url: `/tenants/${id}/${revision}/${active}`, method: 'PUT'
    },
      );
    }
  
const postTenantsIdRepair = (
    id: string | null,
 ) => {
      return customInstance<boolean>(
      {url: `/tenants/${id}/repair`, method: 'POST'
    },
      );
    }
  
const getMeRole = (
    
 ) => {
      return customInstance<UserRole>(
      {url: `/me/role`, method: 'GET'
    },
      );
    }
  
const getAvailable = (
    
 ) => {
      return customInstance<IAvailableUsersAvailableUsers[]>(
      {url: `/available`, method: 'GET'
    },
      );
    }
  
const postSyncUsers = (
    
 ) => {
      return customInstance<IAddUserAddUsersUsers[]>(
      {url: `/sync-users`, method: 'POST'
    },
      );
    }
  
return {getAdminUsers,postAdminUsersProviderUserIdSuperadmin,deleteAdminUsersId,getTenantsTenantIdCertificateCertificateType,getTenantsTenantIdCertificatesCertificateTypeDownload,putTenantsTenantIdCertificatesSmimeDecryption,putTenantsTenantIdCertificatesSmimeEncryption,putTenantsTenantIdCertificatesClientAuth,getTenantsTenantIdUsers,postTenantsTenantIdUsers,deleteTenantsTenantIdUsersUserId,putPersonsId,getTenants,postTenants,getTenantsId,putTenantsId,putTenantsIdRevisionActive,postTenantsIdRepair,getMeRole,getAvailable,postSyncUsers}};

type AwaitedInput<T> = PromiseLike<T> | T;

    type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export type GetAdminUsersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['getAdminUsers']>>>
export type PostAdminUsersProviderUserIdSuperadminResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['postAdminUsersProviderUserIdSuperadmin']>>>
export type DeleteAdminUsersIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['deleteAdminUsersId']>>>
export type GetTenantsTenantIdCertificateCertificateTypeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['getTenantsTenantIdCertificateCertificateType']>>>
export type GetTenantsTenantIdCertificatesCertificateTypeDownloadResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['getTenantsTenantIdCertificatesCertificateTypeDownload']>>>
export type PutTenantsTenantIdCertificatesSmimeDecryptionResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['putTenantsTenantIdCertificatesSmimeDecryption']>>>
export type PutTenantsTenantIdCertificatesSmimeEncryptionResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['putTenantsTenantIdCertificatesSmimeEncryption']>>>
export type PutTenantsTenantIdCertificatesClientAuthResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['putTenantsTenantIdCertificatesClientAuth']>>>
export type GetTenantsTenantIdUsersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['getTenantsTenantIdUsers']>>>
export type PostTenantsTenantIdUsersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['postTenantsTenantIdUsers']>>>
export type DeleteTenantsTenantIdUsersUserIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['deleteTenantsTenantIdUsersUserId']>>>
export type PutPersonsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['putPersonsId']>>>
export type GetTenantsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['getTenants']>>>
export type PostTenantsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['postTenants']>>>
export type GetTenantsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['getTenantsId']>>>
export type PutTenantsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['putTenantsId']>>>
export type PutTenantsIdRevisionActiveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['putTenantsIdRevisionActive']>>>
export type PostTenantsIdRepairResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['postTenantsIdRepair']>>>
export type GetMeRoleResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['getMeRole']>>>
export type GetAvailableResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['getAvailable']>>>
export type PostSyncUsersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDomainAdminService>['postSyncUsers']>>>
